import React from 'react'
import { IconType } from 'react-icons'

interface IconWrapperProps {
	icon: IconType
	className?: string
	style?: React.CSSProperties
	size?: string | number
}

const IconWrapper: React.FC<IconWrapperProps> = ({ 
	icon: Icon, 
	className, 
	style, 
	size 
}) => {
	return React.createElement(Icon as React.ComponentType<any>, { className, style, size })
}

export default IconWrapper 